var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!this.favoritesOnly)?_c('search-panel',{attrs:{"autofocus":true,"fields":_vm.searchFields,"showMaxRows":true,"maxRows":_vm.maxRows,"submitBtn":true,"mainAction":_vm.mainAction},model:{value:(_vm.searchParams),callback:function ($$v) {_vm.searchParams=$$v},expression:"searchParams"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }